import Icon from '../components/Icon.vue'

Icon.register({
  'user-graduate': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M319.4 320.6c71.5 3.1 128.6 61.6 128.6 133.8v9.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-9.6c0-72.2 57.1-130.7 128.6-133.8l95.4 95.4zM13.6 79.8c-18.1-4.4-18.1-27.2 0-31.6l190.6-45.9c13-3.1 26.7-3.1 39.7 0l190.4 46c18.2 4.4 18.2 27.1 0 31.5l-96.3 23.2c8.7 17.2 14 36.4 14 57 0 70.7-57.3 128-128 128s-128-57.3-128-128c0-20.6 5.4-39.8 14-57l-66-15.9v52.6c7 4.2 12 11.5 12 20.3 0 8.4-4.6 15.4-11.1 19.7l15.6 62.3c1.7 6.9-2.1 14-7.6 14h-41.8c-5.5 0-9.3-7.1-7.6-14l15.6-62.3c-6.5-4.3-11.1-11.3-11.1-19.7 0-8.8 5-16.1 12-20.3v-58.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-graduate.js
// module id = 2063
// module chunks = 0